module.exports = __webpack_public_path__ + "img/gold_goldbank.2888bd4.png";